import { TmcContextService } from './../../tmc-context.service';
import { YardConfiguration } from './../../../client/model/yard-configuration';
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { StructureSelectionDialogComponent } from "./component/structure-selection-dialog/structure-selection-dialog.component";
import { StructureSelctionFilter, StructureSelection, StructureSelectionScope, StructureSelectionRequest } from "../structure-selection.model";

@Injectable({
  providedIn: 'root'
})
export class StructureSelectionService {

  yardConfiguration: YardConfiguration;

  constructor(
    private dialog: MatDialog,
    private tmcContextService: TmcContextService
  ) {
    this.tmcContextService.updated.subscribe(
      yardConfiguration => {
        this.yardConfiguration = yardConfiguration;
      }
    );
  }

  selectAny(selection: StructureSelection): Observable<any> {
    this.extendSelection(selection);
    return this.showDialog(new StructureSelectionRequest({ scope: StructureSelectionScope.ANY, selection: selection, filter: StructureSelctionFilter.ANY }));
  }

  selectStationSetOrStation(selection: StructureSelection): Observable<any> {
    this.extendSelection(selection);
    return this.showDialog(new StructureSelectionRequest({ scope: StructureSelectionScope.STATION_OR_STATION_SET, selection: selection, filter: StructureSelctionFilter.ANY }));
  }

  selectStation(selection: StructureSelection): Observable<any> {
    this.extendSelection(selection);
    return this.showDialog(new StructureSelectionRequest({ scope: StructureSelectionScope.STATION, selection: selection, filter: StructureSelctionFilter.ANY }));
  }

  selectWaitingArea(selection: StructureSelection): Observable<any> {
    this.extendSelection(selection);
    return this.showDialog(new StructureSelectionRequest({ scope: StructureSelectionScope.STATION, selection: selection, filter: StructureSelctionFilter.WAITING_AREA }));
  }

  selectStationSet(selection: StructureSelection): Observable<any> {
    this.extendSelection(selection);
    return this.showDialog(new StructureSelectionRequest({ scope: StructureSelectionScope.STATION_SET, selection: selection, filter: StructureSelctionFilter.ANY }));
  }

  selectStationGroupOrStationSet(selection: StructureSelection): Observable<any> {
    this.extendSelection(selection);
    return this.showDialog(new StructureSelectionRequest({ scope: StructureSelectionScope.STATION_SET_OR_STATION_GROUP, selection: selection, filter: StructureSelctionFilter.ANY }));
  }

  private extendSelection(selection: StructureSelection) {

    /* falls beim Aufruf die Gruppe nicht gesetzt ist aber das station set, dann die gruppe ergänzen */
    if (selection.stationSetId != null && selection.stationGroupId == null) {
      if (this.yardConfiguration != null) {
        for (let group of this.yardConfiguration.stationGroups) {
          for (let stationSet of group.stationSets) {
            if (stationSet.id === selection.stationSetId) {
              selection.stationGroupId = group.id;
            }
          }
        }
      } else {
        console.warn('yard configuration is not yet initialized');
      }
    }

  }

  private showDialog(selectionContext: StructureSelectionRequest): Observable<any> {
    return this.dialog.open(StructureSelectionDialogComponent, {
      height: '95%',
      width: '95%',
      maxHeight: '960px',
      maxWidth: '1280px',
      data: selectionContext
    }).afterClosed();
  }
}
